/**
 * contentItem query including contentPackage fields
 * @returns {string} contentItem query
 */

import { leadMediaFragment, segmentFragment } from "../fragments/contentItem";

export function contentPackage(contentId, contentStatus = "") {
    return `
    query {
        contentItem(sourceId: "${contentId}", contentStatus:"${contentStatus}") {
            id
            type
            url
            editorialSource
            title
            deck
            shareHeadline
            description
            language
            flag
            publishedAt
            updatedAt
            mediaid: mediaId
            imageLarge
            leadMedia {
              ...leadMedia
            }
            categories {
              id
              name
              type
              slug
              path
            }
            section {
              social {
                facebookPages
              }
            }
            tags {
              name
              type
            }
            concepts {
              type
              path
            }
            episode {
              segments {
                ...segment
              }
            }
            components {
              mainContent {
                  id
                  sourceId
                  type
                  url
                  description
                  sectionList
                  imageLarge
              }
              mainVisual {
                  ... on ContentItem {
                      publishedAt
                      mediaId
                      sourceId
                      media {
                        duration
                        hasCaptions
                        streamType
                      }
                      title
                      imageLarge
                  }
              }
              primary
              secondary
            }
          }
        }
        ${leadMediaFragment}
        ${segmentFragment}
    `;
}
